module.exports = __webpack_public_path__ + "images/category_lp/retro_game/assessment_achievements/5@2x_639ac8b2399c07772c758be0164db73f.png";